// SEO & GEO Assessment — Results Page JS
// Reads JSON from #seo-report-json and renders the full dashboard

function initSeoResults() {
  const payload = document.querySelector("#seo-report-json");
  if (!payload) return;

  initSeoContactPanel();

  const encodedReport = payload.dataset.report || "";
  if (!encodedReport) return;

  let data;
  try {
    data = JSON.parse(decodeBase64Utf8(encodedReport));
    if (typeof data === "string") data = JSON.parse(data);
  } catch {
    return;
  }

  if (!data || typeof data !== "object") return;

  renderSeoDashboard(data);
}

function initSeoContactPanel() {
  const sidebar = document.querySelector(".seo-contact-sidebar");
  if (!sidebar) return;
  if (sidebar.dataset.seoContactBound) return;
  sidebar.dataset.seoContactBound = "true";

  const toggles = document.querySelectorAll("[data-seo-contact-toggle]");
  const closers = document.querySelectorAll("[data-seo-contact-close]");
  const mediaQuery = window.matchMedia("(max-width: 1023px)");

  function syncToggleState(isOpen) {
    toggles.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  function closePanel() {
    sidebar.classList.remove("is-open");
    document.body.classList.remove("seo-contact-panel-open");
    sidebar.querySelector(".seo-contact-panel")?.setAttribute("aria-hidden", "true");
    syncToggleState(false);
  }

  function openPanel() {
    if (!mediaQuery.matches) return;
    sidebar.classList.add("is-open");
    document.body.classList.add("seo-contact-panel-open");
    sidebar.querySelector(".seo-contact-panel")?.setAttribute("aria-hidden", "false");
    syncToggleState(true);
  }

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      if (sidebar.classList.contains("is-open")) {
        closePanel();
        return;
      }
      openPanel();
    });
  });

  closers.forEach((closer) => {
    closer.addEventListener("click", closePanel);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closePanel();
  });

  const handleViewportChange = (event) => {
    if (!event.matches) closePanel();
  };

  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", handleViewportChange);
  } else {
    mediaQuery.addListener(handleViewportChange);
  }
}

function decodeBase64Utf8(encodedValue) {
  const binary = window.atob(encodedValue);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

// ── Dashboard ───────────────────────────────────────────────────────────────

function renderSeoDashboard(data) {
  const dd      = data.dashboard_data || {};
  const summary = dd.summary          || {};
  const charts  = dd.charts           || {};

  // Three score gauges
  drawSeoGauge("seo-gauge-overall", summary.overall_score ?? 0, summary.overall_score_color ?? "red", true);
  drawSeoGauge("seo-gauge-seo",     summary.seo_score     ?? 0, summary.seo_score_color     ?? "red", false);
  drawSeoGauge("seo-gauge-geo",     summary.geo_score     ?? 0, summary.geo_score_color     ?? "red", false);

  // Badges in hero
  const badgeIssues = document.querySelector("#seo-badge-issues");
  const badgeCrit   = document.querySelector("#seo-badge-critical");
  if (badgeIssues) badgeIssues.textContent = `${summary.total_issues    ?? "—"} problemi totali`;
  if (badgeCrit)   badgeCrit.textContent   = `${summary.critical_issues ?? "—"} critici`;

  // Metrics strip
  const totalEl = document.querySelector("#seo-metric-total-issues");
  const critEl  = document.querySelector("#seo-metric-critical-issues");
  if (totalEl) totalEl.textContent = summary.total_issues    ?? "—";
  if (critEl)  critEl.textContent  = summary.critical_issues ?? "—";

  // Charts
  if (charts.severity_distribution) drawSeoPie("seo-chart-severity",     charts.severity_distribution);
  if (charts.heuristic_violations)  drawSeoBar("seo-chart-violations",   charts.heuristic_violations);

  // Critical issues table
  renderSeoCriticalTable(dd.top_3_critical_issues || []);

  // Issues accordion (failed rules only)
  renderSeoAccordion(data.issues_detected || []);

  // Positive summary
  renderSeoPositiveSummary(data.positive_summary || "");

  // Strategic action plan
  renderSeoPlan(data.strategic_action_plan || []);
}

// ── Circular gauge (SVG) ────────────────────────────────────────────────────

const SEO_COLOR_MAP = { green: "#00c36f", orange: "#ff7517", red: "#e63131" };

function drawSeoGauge(containerId, score, colorKey, isLarge) {
  const wrap = document.getElementById(containerId);
  if (!wrap) return;

  const size     = isLarge ? 160 : 110;
  const cx       = size / 2, cy = size / 2;
  const r        = isLarge ? 62 : 42;
  const sw       = isLarge ? 10  : 8;
  const circ     = 2 * Math.PI * r;
  const color    = SEO_COLOR_MAP[colorKey] || SEO_COLOR_MAP.red;
  const fontSize = isLarge ? 44 : 28;
  const targetOffset = circ - (score / 100) * circ;

  wrap.innerHTML = `
    <svg viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" style="display:block">
      <circle cx="${cx}" cy="${cy}" r="${r}" fill="none"
        stroke="rgba(255,255,255,0.08)" stroke-width="${sw}"/>
      <circle class="seo-gauge-arc" cx="${cx}" cy="${cy}" r="${r}" fill="none"
        stroke="${color}" stroke-width="${sw}" stroke-linecap="round"
        stroke-dasharray="${circ}" stroke-dashoffset="${circ}"
        style="transform-box:fill-box;transform-origin:center;transition:stroke-dashoffset 1.4s cubic-bezier(0.22,1,0.36,1)"
        data-target="${targetOffset}"/>
      <text x="${cx}" y="${cy + fontSize * 0.36}" text-anchor="middle"
        font-family="Area Inktrap Extrablack, Impact, sans-serif"
        font-size="${fontSize}" font-weight="400" fill="${color}">${score}</text>
    </svg>`;

  const arc = wrap.querySelector(".seo-gauge-arc");
  if (arc) {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      arc.style.strokeDashoffset = targetOffset;
    }));
  }
}

// ── Donut pie chart ─────────────────────────────────────────────────────────

function drawSeoPie(containerId, chartData) {
  const el = document.getElementById(containerId);
  if (!el) return;

  const labels = chartData.labels || [];
  const values = chartData.data   || [];
  const total  = values.reduce((a, b) => a + b, 0);

  if (total === 0) {
    el.innerHTML = '<p style="color:#999;font-size:.8rem;text-align:center;padding:2rem 0">Nessun problema rilevato</p>';
    return;
  }

  const COLORS = ["#e63131", "#ff7517", "#f5c518", "#cccccc"];
  const size = 160, cx = size / 2, cy = size / 2, r = 60, innerR = 26;

  let paths = "", legend = "";
  let startAngle = -Math.PI / 2;

  values.forEach((val, i) => {
    const color = COLORS[i % COLORS.length];
    if (!val) {
      legend += `<li style="opacity:.4"><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};margin-right:6px;vertical-align:middle"></span>${escSeoHtml(labels[i] || "")} <strong>0</strong></li>`;
      return;
    }
    const slice = (val / total) * 2 * Math.PI;
    const end   = startAngle + slice;
    const x1 = cx + r * Math.cos(startAngle), y1 = cy + r * Math.sin(startAngle);
    const x2 = cx + r * Math.cos(end),         y2 = cy + r * Math.sin(end);
    const xi1 = cx + innerR * Math.cos(end),   yi1 = cy + innerR * Math.sin(end);
    const xi2 = cx + innerR * Math.cos(startAngle), yi2 = cy + innerR * Math.sin(startAngle);
    const large = slice > Math.PI ? 1 : 0;
    paths  += `<path d="M${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2} L${xi1},${yi1} A${innerR},${innerR} 0 ${large},0 ${xi2},${yi2} Z" fill="${color}" opacity="0.92"/>`;
    legend += `<li><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};margin-right:6px;vertical-align:middle;flex-shrink:0"></span>${escSeoHtml(labels[i] || "")} <strong>${val}</strong></li>`;
    startAngle = end;
  });

  el.innerHTML = `
    <div style="display:flex;gap:1.5rem;align-items:center;flex-wrap:wrap">
      <svg viewBox="0 0 ${size} ${size}" width="${size}" height="${size}" style="flex-shrink:0">
        ${paths}
        <circle cx="${cx}" cy="${cy}" r="${innerR}" fill="#fff"/>
      </svg>
      <ul style="list-style:none;padding:0;margin:0;font-size:.78rem;line-height:2.1;color:#0a0a0a;font-family:Exo,sans-serif;display:flex;flex-direction:column;gap:0">${legend}</ul>
    </div>`;
}

// ── Bar chart ───────────────────────────────────────────────────────────────

function drawSeoBar(containerId, chartData) {
  const el = document.getElementById(containerId);
  if (!el) return;

  const labels = chartData.labels || [];
  const values = chartData.data   || [];
  const maxVal = Math.max(...values, 1);
  const COLORS = ["#1400ff", "#ff7517", "#00c36f"];

  el.innerHTML = `<div style="padding:.25rem 0">${
    values.map((v, i) => {
      const color = COLORS[i % COLORS.length];
      return `
        <div style="margin-bottom:.9rem">
          <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:.3rem">
            <span style="font-size:.68rem;font-weight:800;text-transform:uppercase;letter-spacing:.07em;font-family:Exo,sans-serif;color:#0a0a0a">${escSeoHtml(labels[i] || "")}</span>
            <span style="font-size:.9rem;font-weight:800;font-family:Exo,sans-serif;color:${color}">${v}</span>
          </div>
          <div style="height:8px;background:#f0f0f0;overflow:hidden">
            <div class="seo-bar-fill" data-pct="${(v / maxVal) * 100}"
                 style="height:100%;width:0;background:${color};transition:width 1.1s cubic-bezier(0.22,1,0.36,1)"></div>
          </div>
        </div>`;
    }).join("")
  }</div>`;

  requestAnimationFrame(() => {
    el.querySelectorAll(".seo-bar-fill").forEach(bar => {
      requestAnimationFrame(() => { bar.style.width = `${bar.dataset.pct}%`; });
    });
  });
}

// ── Critical issues table ────────────────────────────────────────────────────

function renderSeoCriticalTable(issues) {
  const tbody = document.querySelector("#seo-critical-body");
  if (!tbody) return;

  tbody.innerHTML = issues.map(issue => {
    const sev = (issue.severity || "").toLowerCase();
    return `
      <tr>
        <td>${escSeoHtml(issue.issue || "")}</td>
        <td><span class="seo-severity-badge seo-severity-${sev}">${escSeoHtml(issue.severity || "")}</span></td>
      </tr>`;
  }).join("");
}

// ── Issues accordion (failed rules only) ───────────────────────────────────

function renderSeoAccordion(issues) {
  const container = document.querySelector("#seo-accordion-body");
  if (!container) return;

  if (!issues.length) {
    container.innerHTML = '<p style="color:#999;font-size:.85rem;text-align:center;padding:2rem 0">Nessun problema rilevato.</p>';
    return;
  }

  const seoOnPage = issues.filter(r => r.category === "SEO On-Page");
  const seoTech   = issues.filter(r => r.category === "SEO Tecnica");
  const geo       = issues.filter(r => r.category === "GEO" || r.category === "GEO & Semantica");

  container.innerHTML =
    renderSeoGroup("Motori di Ricerca — SEO On-Page", seoOnPage) +
    renderSeoGroup("SEO Tecnica & Strutturale", seoTech) +
    renderSeoGroup("Motori Generativi AI — GEO & Semantica", geo);

  container.querySelectorAll(".seo-rule-header").forEach(header => {
    const rule = header.closest(".seo-rule");
    if (!rule) return;
    header.setAttribute("tabindex", "0");
    header.setAttribute("role", "button");
    function toggle() { rule.classList.toggle("seo-rule--open"); }
    header.addEventListener("click", toggle);
    header.addEventListener("keypress", e => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); }
    });
  });
}

function renderSeoGroup(title, issues) {
  if (!issues.length) return "";
  return `
    <div class="seo-accordion-group">
      <h3 class="seo-group-title">${title}</h3>
      <div class="seo-rules-list">${issues.map(renderSeoRuleItem).join("")}</div>
    </div>`;
}

function renderSeoRuleItem(rule) {
  return `
    <div class="seo-rule">
      <div class="seo-rule-header">
        <span class="seo-rule-id">${String(rule.rule_id ?? "").padStart(2, "0")}</span>
        <span class="seo-rule-name">${escSeoHtml(rule.rule_name || "")}</span>
        <span class="seo-status-dot seo-dot--fail" title="Fail"></span>
        <span class="seo-rule-chevron" aria-hidden="true"></span>
      </div>
      <div class="seo-rule-body">
        <p class="seo-rule-explanation">${escSeoHtml(rule.explanation || "")}</p>
      </div>
    </div>`;
}

// ── Positive summary ─────────────────────────────────────────────────────────

function renderSeoPositiveSummary(text) {
  const el = document.querySelector("#seo-positive-summary");
  if (!el || !text) return;
  el.textContent = text;
  el.closest(".seo-positive-section")?.removeAttribute("hidden");
}

// ── Strategic action plan ────────────────────────────────────────────────────

function renderSeoPlan(plan) {
  const list = document.querySelector("#seo-plan-list");
  if (!list) return;

  list.innerHTML = plan.map(item =>
    `<li>${escSeoHtml(item)}</li>`
  ).join("");
}

// ── Utility ──────────────────────────────────────────────────────────────────

function escSeoHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

document.addEventListener("turbo:load", initSeoResults);
